/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Specifies the tax calculation mode for the transaction. If set to "inclusive," the tax is included in the price. If set to "exclusive," the tax is added on top of the price.
 */
export const TaxMode = {
  Inclusive: "inclusive",
  Exclusive: "exclusive",
} as const;
/**
 * Specifies the tax calculation mode for the transaction. If set to "inclusive," the tax is included in the price. If set to "exclusive," the tax is added on top of the price.
 */
export type TaxMode = ClosedEnum<typeof TaxMode>;

/** @internal */
export const TaxMode$inboundSchema: z.ZodNativeEnum<typeof TaxMode> = z
  .nativeEnum(TaxMode);
/** @internal */
export const TaxMode$outboundSchema: z.ZodNativeEnum<typeof TaxMode> =
  TaxMode$inboundSchema;
